module.exports = __webpack_public_path__ + "assets/images/3-INVALID.024149e9.svg";